module.exports = __webpack_public_path__ + "img/banner-first.095fce21.jpg";